"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var EmailOutline = function (props) {
    return ((0, jsx_runtime_1.jsx)(Icon_1.default, tslib_1.__assign({}, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M28 44.0001V44H28.0001L28 44.0001ZM164 44.0967V148H28V44.0001L94.8545 110.855L94.9028 110.806L96.0966 112L164 44.0967ZM164 44.0414V44H163.959L164 44.0414ZM147.126 44H44.9705L96.0483 95.0778L147.126 44ZM16 42C16 36.4772 20.4772 32 26 32H166C171.523 32 176 36.4772 176 42V150C176 155.523 171.523 160 166 160H26C20.4772 160 16 155.523 16 150V42Z' }) })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = EmailOutline;
